import script from "./Swap.vue?vue&type=script&lang=ts&setup=true"
export * from "./Swap.vue?vue&type=script&lang=ts&setup=true"

import "./Swap.vue?vue&type=style&index=0&id=355fe833&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-355fe833"]])

export default __exports__